"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateWardSchema = exports.createWardSchema = exports.wardShape = exports.wardGenderEnum = exports.wardTypeEnum = void 0;
const zod_1 = require("zod");
// Hospital Infrastructure — Ward Master. See schema.prisma's `Ward`
// model doc comment for the full hierarchy context (Ward ->
// NursingStation -> Room -> Bed).
exports.wardTypeEnum = zod_1.z.enum([
    'GENERAL',
    'CRITICAL_CARE',
    'SURGICAL',
    'MATERNITY',
    'SPECIALITY',
    'DAY_CARE',
]);
exports.wardGenderEnum = zod_1.z.enum(['MALE', 'FEMALE', 'MIXED']);
exports.wardShape = {
    branchId: zod_1.z.string().uuid().nullable().optional(),
    codeGroup: zod_1.z.string().min(1).max(10),
    wardCode: zod_1.z.string().min(1).max(20),
    name: zod_1.z.string().min(1).max(255),
    type: exports.wardTypeEnum,
    category: zod_1.z.string().max(100).nullable().optional(),
    building: zod_1.z.string().max(150).nullable().optional(),
    floor: zod_1.z.string().max(50).nullable().optional(),
    gender: exports.wardGenderEnum.optional(),
    isIsolationWard: zod_1.z.boolean().optional(),
    allowAdmission: zod_1.z.boolean().optional(),
    displayOrder: zod_1.z.number().int().min(0).optional(),
    departmentHeadId: zod_1.z.string().uuid().nullable().optional(),
    wardInchargeId: zod_1.z.string().uuid().nullable().optional(),
    defaultChargeCategoryId: zod_1.z.string().uuid().nullable().optional(),
    isActive: zod_1.z.boolean().optional(),
};
exports.createWardSchema = zod_1.z.object(exports.wardShape);
exports.updateWardSchema = exports.createWardSchema.partial();
//# sourceMappingURL=ward.schema.js.map